<template>
  <div class="Site PageBox">
    <van-nav-bar
      fixed
      :border="false"
      :title="$t('Partner[2][1]')"
      left-arrow
      @click-left="$router.go(-1)"
    />
    <div class="ScrollBox">
      <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
        <van-list
          v-model="isLoad"
          :finished="isFinished"
          :finished-text="listData.length?$t('vanPull[0]'):$t('vanPull[1]')"
          @load="onLoad"
          :class="{Empty:!listData.length}"
        >
          <van-cell class="item" v-for="(item,index) in listData" :key="index" :border="false">
            <template #title>
              {{$t('Partner[9][0]')}}:{{item.username}}
            </template>
            <template #label>
              <p>{{$t('Partner[9][1]')}}:{{item.name}}</p>
              <p>{{$t('Partner[9][2]')}}:{{item.y_copies}} / {{item.all_copies}}</p>
              <p>{{$t('Partner[9][9]')}}:{{item.create_time}}</p>
            </template>
            <template #extra>
              <div class="right">
                <div class="price">
                  <p>{{$t('Partner[9][3]')}}</p>
                  <b>{{InitData.currency}}{{$Util.KeepDecimal(item.amount/item.all_copies,2)}}</b>
                </div>
                <div>
                  <van-button type="danger" size="mini" round @click.stop="showJoin=true,formData.cid=item.id,currPartner=item">{{$t('Partner[9][8]')}}</van-button>
                </div>
              </div>
            </template>
          </van-cell>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-dialog v-model="showJoin" :title="$t('Partner[2][1]')" show-cancel-button @confirm="joinPartner" @closed="formData.copies=1">
      <van-field
        :value="formData.copies"
        name="copies"
        :label="$t('Partner[5][0]')"
        :placeholder="$t('Partner[5][1]')"
        :rules="[{ required: true, message: $t('Partner[5][1]') }]"
        size="large"
        readonly
        input-align="right"
        style="padding: 20px 16px"
      >
        <template #input>
          <van-stepper v-model="formData.copies" integer input-width="60" button-size="36" min="1" :max="currPartner.s_copies" />
        </template>
      </van-field>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'TaskRecord',
  components: {
  },
  props: ['taskState'],
  data() {
    return {
      listData: '',
      isLoad: false,
      isFinished: false,
      isRefresh: false,
      pageNo: 1,
      tabsState: 2,
      showJoin: false,
      currPartner: '',
      formData: {
        cid: '',
        copies: 1
      },
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.getListData('init')
  },
  mounted() {
    
  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    joinPartner() {
      this.$Model.JoinPartner(this.formData,data=>{
        this.showJoin = false
        if(data.code==1){
          this.getListData('init')
        }
      })
    },
    onLoad() {
      this.getListData('load')
    },
    changeTabs() {
      this.getListData('init')
    },
    getListData(type) {
      this.isLoad = true
      this.isRefresh = false
      if(type=='load'){
        this.pageNo+=1
      }else{
        this.pageNo = 1
        this.isFinished = false
      }
      this.$Model.GetJoinPartner({state: this.tabsState,page_no: this.pageNo},data=>{
        this.isLoad = false
        if(data.code==1){
          if(type=='load'){
            this.listData = this.listData.concat(data.list);
          }else{
            this.listData = data.list
          }
          if(this.pageNo==data.data_total_page){
            this.isFinished = true
          }else{
            this.isFinished = false
          }
        }else{
          this.listData = ''
          this.isFinished = true
        }
      })
    },
    onRefresh() {
      this.getListData('init')
    },
  }
}
</script>
<style scoped>
.van-tabs>>>.van-tab{
  padding: 0 10px;
}
.van-uploader{
  display: block;
  margin-top: 10px;
}
.van-uploader>>>.van-uploader__upload-icon{
  font-size: 16px;
}
.van-uploader>>>.van-uploader__wrapper{
  justify-content: flex-end;
  flex-direction: column;
  align-items: flex-end;
}
.van-uploader>>>.van-uploader__upload,.van-uploader>>>.van-uploader__preview-image{
  width: 36px;
  height: 36px;
  margin-right: 0;
  border-radius: 5px;
}
.van-uploader>>>.van-uploader__preview{
  margin-right: 0;
  border-radius: 5px;
  overflow: hidden;
}
.van-uploader>>>.van-uploader__mask-message{
  white-space: nowrap;
}
.van-pull-refresh{
  min-height: calc(100vh - 90px);
}
.van-list{
  overflow: hidden;
  padding: 0 10px;
}
.van-list>>>.item{
  margin: 10px 0;
  border-radius: 10px;
  padding: 15px;
}
.item .van-cell__title{
  font-size: 15px;
}
.item .van-cell__label{
  line-height: 1;
  margin-top: 8px;
}
.item .van-cell__label p{
  margin-top: 8px;
}
.item .right{
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-left: 10px;
  font-size: 12px;
  color: #999;
}
.item .right .price{
  text-align: center;
  margin-bottom: 10px;
}
.item .right .price b{
  color: var(--color-active);
  font-size: 16px;
  margin-top: 5px;
  display: block;
}
.item .right .van-button{
  margin-left: 5px;
}
.van-field>>>.van-field__label{
  font-weight: 600;
}
</style>